import { I18n } from '../models/i18n'
import { Portal } from '../models/permissions'
import { UserState } from '../redux/states'

export class LocalStorage {
    private static shared: LocalStorage
    private constructor() {}

    public static ACCESS_TOKEN_KEY: string = 'ROOT_ACCESS_TOKEN'
    public static REFRESH_TOKEN_KEY: string = 'ROOT_REFRESH_TOKEN'
    public static I18N_KEY: string = '_i18n'
    public static USER_KEY: string = 'ROOT_USER'
    public static SELECTED_PORTAL_CODE: string = 'SELECTED_PORTAL_CODE'
    public static DEFAULT_APP_PATH: string = 'DEF_APP_PATH'
    public static PERMISSIONS_KEY: string = '_PERMISSIONS'

    public static _shared(): LocalStorage {
        if (!LocalStorage.shared) {
            LocalStorage.shared = new LocalStorage()
        }

        return LocalStorage.shared
    }

    public static getAccessToken = (): string => {
        return localStorage.getItem(LocalStorage.ACCESS_TOKEN_KEY)
    }
    public static getRefreshToken = (): string => {
        return localStorage.getItem(LocalStorage.REFRESH_TOKEN_KEY)
    }

    public setAccessToken = (token: string) => {
        this._set(LocalStorage.ACCESS_TOKEN_KEY, token)
    }
    public setPortal = (code: string) => {
        this._set(LocalStorage.SELECTED_PORTAL_CODE, code)
    }
    public setDefaultAppPath = (path: string) => {
        this._set(LocalStorage.DEFAULT_APP_PATH, path)
    }

    public setRefreshToken = (token: string) => {
        this._set(LocalStorage.REFRESH_TOKEN_KEY, token)
    }

    public clearToken = () => {
        localStorage.removeItem(LocalStorage.ACCESS_TOKEN_KEY)
        localStorage.removeItem(LocalStorage.REFRESH_TOKEN_KEY)
    }
    public clearSelectedPortal = () => {
        localStorage.removeItem(LocalStorage.SELECTED_PORTAL_CODE)
    }
    public setI18n = (i18n: I18n, app: string = 'ROOT') => {
        this._set(app + LocalStorage.I18N_KEY, JSON.stringify(i18n))
    }
    public getI18n = (app: string = 'ROOT'): I18n => {
        try {
            return JSON.parse(this._get(app + LocalStorage.I18N_KEY))
        } catch (error) {
            // console.error(error)
            return undefined
        }
    }
    public setUser = (user: any) => {
        this._set(LocalStorage.USER_KEY, JSON.stringify(user))
    }
    public getUser = (): any => {
        try {
            return (
                JSON.parse(this._get(LocalStorage.USER_KEY)) || {
                    name: 'Fabio',
                    lastname: 'Cingolani',
                }
            )
        } catch (error) {
            return undefined
        }
    }
    public _get = (key: string): string => {
        return localStorage.getItem(key) || ''
    }
    public _set = (key: string, data: string) => {
        localStorage.setItem(key, data)
    }
    public clearI18n = (app: string) => {
        localStorage.removeItem(app + LocalStorage.I18N_KEY)
    }

    public getPermissions = (app: string = 'ROOT'): any => {
        try {
            return JSON.parse(this._get(app + LocalStorage.PERMISSIONS_KEY))
        } catch (error) {
            return undefined
        }
    }

    public setPermissions = (permissions: any, app: string = 'ROOT') => {
        this._set(
            app + LocalStorage.PERMISSIONS_KEY,
            JSON.stringify(permissions)
        )
    }

    public getPersistentData = (app?: string): UserState => {
        return {
            accessToken: LocalStorage.getAccessToken(),
            refreshToken: LocalStorage.getRefreshToken(),
            permissions: this.getPermissions(),
            user: this.getUser(),
            i18n: this.getI18n(app),
            loading: false,
            isUserAuthenticated:
                LocalStorage.getAccessToken() &&
                LocalStorage.getAccessToken() !== '',
        } as UserState
    }

    public setPersistentData = (data: UserState, app?: string) => {
        this.setUser(data.user)
        this.setAccessToken(data.accessToken)
        this.setRefreshToken(data.refreshToken)
        this.setI18n(data.i18n, app)
        this.setPermissions(data.permissions)
    }
}
